"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
var e = require("./extends-fa579b0f.js"),
  a = require("./objectWithoutProperties-2581b642.js"),
  t = require("react"),
  r = require("prop-types"),
  n = require("classnames"),
  l = require("./grid-965d799c.js"),
  d = require("./styles-df7980c2.js");
function u(e) {
  return e && "object" == _typeof(e) && "default" in e ? e : {
    "default": e
  };
}
var i = u(t),
  o = u(r),
  s = u(n),
  c = ["backgroundVariant", "branding", "children", "className", "disableBottomPadding", "disableTopPadding", "hasTexture", "id", "moduleName", "moduleVariation", "textureGranuleColor", "textureGranuleShape", "themeType"],
  m = i["default"].forwardRef(function (t, r) {
    var n = t.backgroundVariant,
      u = t.branding,
      o = t.children,
      m = t.className,
      g = t.disableBottomPadding,
      f = t.disableTopPadding,
      h = t.hasTexture,
      b = t.id,
      p = t.moduleName,
      x = t.moduleVariation,
      T = t.textureGranuleColor,
      y = t.textureGranuleShape,
      C = t.themeType,
      G = a._objectWithoutProperties(t, c),
      P = {};
    P[m] = m;
    var S = "".concat(b, "-section-container");
    return i["default"].createElement(d.SectionContainerStyled, e._extends({
      backgroundVariant: n,
      branding: u,
      className: s["default"](P, m),
      "data-module": "".concat(S, ":").concat(p, ":").concat(x),
      disableBottomPadding: g,
      disableTopPadding: f,
      hasTexture: h,
      id: S,
      ref: r,
      textureGranuleColor: T,
      textureGranuleShape: y,
      themeType: C
    }, G), h && i["default"].createElement(d.BgTextureLeftContainerStyled, {
      backgroundVariant: n,
      branding: u,
      textureGranuleColor: T,
      textureGranuleShape: y,
      themeType: C
    }), i["default"].createElement(l.Container, null, o), h && i["default"].createElement(d.BgTextureRightContainerStyled, {
      backgroundVariant: n,
      branding: u,
      textureGranuleColor: T,
      textureGranuleShape: y,
      themeType: C
    }));
  });
m.propTypes = {
  backgroundVariant: o["default"].oneOf(["darkDefault", "lightA", "lightB", "lightC", "lightSky"]).isRequired,
  branding: o["default"].oneOf(["nm", "pcg"]),
  children: o["default"].any.isRequired,
  className: o["default"].string,
  disableBottomPadding: o["default"].bool,
  disableTopPadding: o["default"].bool,
  hasTexture: o["default"].bool,
  id: o["default"].string.isRequired,
  moduleName: o["default"].string,
  moduleVariation: o["default"].string,
  textureGranuleColor: o["default"].oneOf(["blue", "sky"]),
  textureGranuleShape: o["default"].oneOf(["circle"]),
  themeType: o["default"].oneOf(["lightTheme", "darkTheme"])
}, m.defaultProps = {
  backgroundVariant: "lightA",
  branding: "nm",
  className: null,
  disableBottomPadding: !1,
  disableTopPadding: !1,
  hasTexture: !1,
  moduleName: "unknown",
  moduleVariation: "A",
  textureGranuleColor: "blue",
  textureGranuleShape: "circle",
  themeType: "lightTheme"
}, exports.SectionContainerComponent = m;